<template>
  <Layout>
    <template slot="title">Mi Cuenta</template>

    <div class="mt-12 max-w-screen-lg m-auto lg:flex lg:justify-center">
      <div class="lg:text-left lg:px-4">
        <p class="text-xl font-bold mb-2 lg:text-3xl">{{ fullName }}</p>
        <p class="text-lg lg:text-xl">{{ email }}</p>
      </div>
      <div class="mt-12 lg:mt-0 lg:pl-20 lg:pr-4 lg:text-left">
        <div class="mt-4">
          <router-link class="hover:underline" :to="{ name: 'Favorites' }">
            Mis Favoritos
          </router-link>
        </div>

        <div class="mt-4">
          <router-link class="hover:underline" :to="{ name: 'History' }">
            Historial de Visualización
          </router-link>
        </div>

        <div class="mt-4">
          <router-link class="hover:underline" :to="{ name: 'PasswordChange' }">
            Cambiar Contraseña
          </router-link>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapState } from 'vuex'
import Layout from '@/layouts/MainLayout'

export default {
  components: { Layout },

  computed: {
    ...mapState('auth', ['fullName', 'email']),
  },

  mounted() {
    this.$store.dispatch('auth/fetchUser')
  },
}
</script>
